<template>
  <cms-stats
    v-if="statsSetUp"
    :theme="statOptions"
    :content="statsContentByVersion"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { isEmpty } from 'lodash';

defineOptions({ name: 'ViewStats' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const theme = computed(() => store.state.theme);
const homepage = computed(() => store.state.homepage);
const isThemePreview = computed(() => store.state.isThemePreview);
const statsContent = computed(() => store.state.statsContent);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const statOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: store.getters['translation/getComponentTranslation']('stats'),
    globalThemeSettings: store.getters.getGlobalThemeSettings,
  };
});

const statsSetUp = computed(() => {
  if (statOptions.value.version === 'S4') {
    return isThemePreview.value
      ? statsContent.value[statOptions.value.version].nested_content
      : !isEmpty(homepage.value?.stats?.[id.value]?.nested_content);
  }
  return !isEmpty(homepage.value?.stats?.[id.value]?.content);
});

const statsContentByVersion = computed(() =>
  isThemePreview.value ? statsContent.value[statOptions.value.version] : homepage.value.stats[id.value],
);
</script>

<style></style>
